export default __webpack_public_path__ + "static/media/test-countdown-img.490e2271.png";